(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lynoriq-access"] && !Shopify.designMode) return;
  try {
    
function initLynoriqAccess(){const dialog=document.getElementById('signin');if(!dialog||dialog.dataset.ready)return;dialog.dataset.ready='true';let opener;if(location.hash==='#signin')dialog.showModal();document.querySelectorAll('[data-lq-signin]').forEach(link=>link.addEventListener('click',e=>{e.preventDefault();opener=link;dialog.showModal()}));dialog.querySelectorAll('[data-lq-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));dialog.addEventListener('close',()=>{if(opener)opener.focus()});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}})}document.addEventListener('DOMContentLoaded',initLynoriqAccess);document.addEventListener('shopify:section:load',initLynoriqAccess);initLynoriqAccess();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lynoriq-header"]) return;
  try {
    
function initLynoriqHeader(){const button=document.querySelector('[data-lq-menu]');const nav=document.getElementById('lq-mobile-nav');if(!button||button.dataset.ready)return;button.dataset.ready='true';function close(){nav.hidden=true;button.setAttribute('aria-expanded','false')}button.addEventListener('click',()=>{nav.hidden=!nav.hidden;button.setAttribute('aria-expanded',String(!nav.hidden))});nav.addEventListener('click',e=>{if(e.target.closest('a'))close()});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!nav.hidden){close();button.focus()}})}document.addEventListener('DOMContentLoaded',initLynoriqHeader);document.addEventListener('shopify:section:load',initLynoriqHeader);initLynoriqHeader();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memora-home"] && !Shopify.designMode) return;
  try {
    
function initMemora(root) {
 if (!root || root.dataset.memoraReady) return;
 root.dataset.memoraReady = 'true';
 const menu = root.querySelector('[data-memora-menu]');
 const nav = root.querySelector('#mobile-marketing-nav');
 function closeMenu() { nav.hidden = true; menu.setAttribute('aria-expanded', 'false'); menu.setAttribute('aria-label', menu.dataset.openLabel); }
 menu.addEventListener('click', () => { const open = nav.hidden; nav.hidden = !open; menu.setAttribute('aria-expanded', String(open)); menu.setAttribute('aria-label', open ? menu.dataset.closeLabel : menu.dataset.openLabel); });
 nav.addEventListener('click', e => { if(e.target.closest('a')) closeMenu(); });
 root.addEventListener('keydown', e => { if(e.key === 'Escape' && !nav.hidden) { closeMenu(); menu.focus(); } });
 const tabs = [...root.querySelectorAll('[data-preview-tab]')];
 function preview(index) { tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; root.querySelector('#preview-panel-' + i).hidden = i !== index; }); }
 tabs.forEach((tab, i) => { tab.addEventListener('click', () => preview(i)); tab.addEventListener('keydown', e => { if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) { e.preventDefault(); const next = e.key === 'Home' ? 0 : e.key === 'End' ? 2 : (i + (e.key === 'ArrowRight' ? 1 : 2)) % 3; preview(next); tabs[next].focus(); } }); });
 const check = root.querySelector('.preview-checkbox');
 check.addEventListener('click', () => { const done = check.getAttribute('aria-pressed') !== 'true'; check.setAttribute('aria-pressed',String(done)); check.setAttribute('aria-label',done ? check.dataset.reopenLabel : check.dataset.completeLabel); check.classList.toggle('checked',done); root.querySelector('.preview-action strong').classList.toggle('preview-completed',done); const due = root.querySelector('.preview-due'); due.textContent = done ? check.dataset.done : check.dataset.due; due.classList.toggle('is-done',done); root.querySelectorAll('.preview-stats strong')[1].textContent = done ? '3' : '4'; const proposal = root.querySelector('[data-proposal-status]'); proposal.textContent = done ? proposal.dataset.complete : proposal.dataset.pending; });
 const steps = [...root.querySelectorAll('[data-workflow-step]')];
 let current = 0;
 function workflow(index) { current = index; steps.forEach((step,i) => {step.classList.toggle('selected', i === index);step.setAttribute('aria-pressed',String(i === index));root.querySelector('[data-workflow-panel="'+i+'"]').hidden=i!==index;});root.querySelector('[data-workflow-counter]').textContent='0'+(index+1)+' / 03'; }
 steps.forEach((step,i) => step.addEventListener('click',() => workflow(i)));
 root.querySelector('[data-workflow-next]').addEventListener('click',() => workflow((current+1)%3));
}
function initAllMemora() { document.querySelectorAll('.marketing-site').forEach(initMemora); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAllMemora);else initAllMemora();
document.addEventListener('shopify:section:load',initAllMemora);


  } catch(e) { console.error(e); }
})();
})();
